import CommonCreate from "@/components/common/Create"
import InventoryForm from "../forms/InventoryForm"
import { inventoryForm } from "@/utils/objects"
import axios from "axios"
import { useState, FormEvent } from "react"
import { useRefresh } from "react-admin"
import { toast } from "sonner"

const InventoryCreate = () => {
    const [formProp, setFormProp] = useState(inventoryForm)

    return (
        <CommonCreate resource="auto-service-inventory" data={{...formProp, supplier_id: +formProp.supplier_id}} title="Inventory" 
        responseMessage={`${formProp.name} added to your inventory`}>
            <InventoryForm mode="create" formProp={formProp} setFormProp={setFormProp}/>
        </CommonCreate>
    )
}

export default InventoryCreate